const ownerCollection = "/user/access-tokens";
const adminCollection = "/admin/access-tokens";

const personalAccessTokensRoutes = {
  ownerCollection: () => ownerCollection,
  adminCollection: () => adminCollection,
  rename: (id: number) => `${ownerCollection}/${id}/name`,
  revoke: (id: number) => `${ownerCollection}/${id}:revoke`,
  delete: (id: number) => `${ownerCollection}/${id}`,
  adminRevoke: (id: number) => `${adminCollection}/${id}:revoke`,
  adminSynchronizeOwner: (lkUserId: number) => `${adminCollection}/owners/${lkUserId}:synchronize`,
  adminTransferUsage: () => `${adminCollection}:transfer-usage`,
  adminEvictCache: () => `${adminCollection}:evict-cache`,
};

export { personalAccessTokensRoutes };
